import { render, staticRenderFns } from "./TheLiveAcquisitionSummary.vue?vue&type=template&id=546ef904&scoped=true"
import script from "./TheLiveAcquisitionSummary.vue?vue&type=script&lang=js"
export * from "./TheLiveAcquisitionSummary.vue?vue&type=script&lang=js"
import style0 from "./TheLiveAcquisitionSummary.vue?vue&type=style&index=0&id=546ef904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ef904",
  null
  
)

export default component.exports
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInnerLoading,QSpinner});
